<template lang="pug">
.pop-menu-button-container
  img.more(
    @click="show = true",
    :src="url"
  )
  .popup(:class="{active: show}")
    template(v-if="menus&&menus.length")
      .menu-item(v-for="(menu, index) in menus" @click="$emit('clickItem', index)")
        img.menu-icon(:src="menu.icon")
        span {{menu.name}}
  .modal(v-if="show" @click="show=false")
</template>

<script>
export default {
  components: {},
  props: {
    icon: {
      type: String,
      default: 'more',
    },
    menus: {
      type: Array,
      default: null,
    },
    url: {
      type: String,
      default: 'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/6c741230-bcf7-4f36-bad8-6ef04672f4e6.svg',
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="less" scoped>
.pop-menu-button-container {
  display: inline-flex;
  position: relative;

  .more {
    width: 0.24rem;
  }

  .modal {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .popup {
    position: absolute;
    right: 0;
    top: 0.28rem;
    width: 1.1rem;
    background: #242729;
    border-radius: 0.04rem;
    opacity: 0;
    padding: 0.1rem 0.12rem;
    overflow: visible;
    z-index: 101;
    transform: translateY(-10%);
    transition: all 0.2s ease;
    pointer-events: none;
    display: flex;
    flex-direction: column;

    &.active {
      opacity: 0.9;
      transform: translateY(0);
      pointer-events: unset;
    }

    &::before {
      content: " ";
      display: block;
      position: absolute;
      top: 1px;
      right: 0.07rem;
      transform: translateY(-99%);
      height: 2px;
      border-left: transparent 5px solid;
      border-right: transparent 5px solid;
      border-bottom: #242729 5px solid;
    }

    .menu-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.14rem;
      color: #fff;

      &:not(:last-of-type) {
        margin-bottom: 0.16rem;
      }

      .menu-icon {
        width: 0.18rem;
        height: 0.18rem;
      }
    }
  }
}
</style>
